import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const topTopicsNPS = createSlice({
  name: 'TopVerbatimPromoterTopic',
  initialState: [
    {
      id: '',
      topValue: null as string | null,
    },
  ],
  reducers: {
    setTopTopicsinNPS(state, action: PayloadAction<{ id: string; topValue: string }>) {
      const { id, topValue } = action.payload
      const existingIndex = state.findIndex((entry) => entry.id === id)
      if (existingIndex !== -1) {
        state[existingIndex].topValue = topValue
      } else {
        state.push({ id, topValue })
      }
    },
  },
})
export const { setTopTopicsinNPS } = topTopicsNPS.actions
export default topTopicsNPS.reducer
